import CheckoutMap from './checkout-map';

'use strict';

class ChooseYourZone {
  constructor(elem) {
    this.target = elem;
    this.stepWrapper = this.target.closest('[data-step-toggle-active]');
    this.checkoutZonesMap = this.target.querySelector('.js-checkout-zones-map');
    this.events();
  }

  open() {
    this.target.classList.add('active');

    if (!this.checkoutZonesMap.checkoutZonesMap) {
      this.checkoutZonesMap.checkoutZonesMap = new CheckoutMap(this.checkoutZonesMap);
    } else {
      this.checkoutZonesMap.checkoutZonesMap.updateMap();
    }
    this.stepWrapper.scrollIntoView();
  }

  close() {
    this.target.classList.remove('active');
  }

  events() {
    // Dispatched once the units of the selected package are loaded.
    this.checkoutZonesMap.addEventListener('open-zone-click', () => {
      this.open();
    }, false);

    document.addEventListener('editStep', () => {
      this.close();
    }, false);
  }
}

const chooseYourZone = document.querySelector('[data-target-zone]');
if (chooseYourZone) {
  chooseYourZone.cyz = new ChooseYourZone(chooseYourZone);
}
